// extracted by mini-css-extract-plugin
module.exports = {"tabsList":"CustomTabs_tabsList__JNU_w","tab":"CustomTabs_tab__bPRFD","secondaryTabsList":"CustomTabs_secondaryTabsList__Ar55M","secondaryTab":"CustomTabs_secondaryTab__LD00R"};